// extracted by mini-css-extract-plugin
module.exports = {"container":"grid_container__1jxF4","winner":"grid_winner__2fKTV"};